<template>
  <div class="py-5">
    <div class="text-center mb-5">
      <h2 class="h3">What is ZoopLocal?</h2>
    </div>
    <div>
      <b-row>
        <b-col
          class="text-right px-5 py-2 d-none d-md-block"
          :cols="12"
          :md="6">
          <img src="/images/home/couch.png"/>
        </b-col>
        <b-col
          class="px-4 py-2">
          <p class="mb-5 description">
            {{ copy.foundingBlurb }}
          </p>
          <b-button
            variant="outline-dark"
            squared
            to="/about">
            Learn More
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { copyForRegion } from '@/copy/regionCopy'

export default {
  name: 'HomeAbout',
  computed: {
    ...mapGetters('Region', { currentRegion: 'current' }),
    copy() {
      return copyForRegion(this.currentRegion.slug)
    },
  },
}
</script>

<style lang="scss" scoped>
.description {
  line-height: 1.75rem;
}
</style>
